import { render, staticRenderFns } from "./DKLXPage.vue?vue&type=template&id=56977eb4&scoped=true"
import script from "./DKLXPage.vue?vue&type=script&lang=js"
export * from "./DKLXPage.vue?vue&type=script&lang=js"
import style0 from "./DKLXPage.vue?vue&type=style&index=0&id=56977eb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56977eb4",
  null
  
)

export default component.exports